<template>
  <wrld-container :breadcrumbs="this.breadcrumbs">
    <wrld-box
      :headerTitle="$tc('routes.routes', 2)"
    >
      <template v-slot:headerBtns>
        <v-btn
          outlined
          :loading="allRoutes.isFetching"
          @click="fetchRoutes()"
        >
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-btn
          color="accent"
          @click="gotoCreateRoute()"
        >{{$t('routes.create_new_btn')}}</v-btn>
      </template>
      <template v-slot:boxContent>
        <v-data-table
          :headers="headers"
          :items="allRoutes.routes"
          :loading="allRoutes.isFetching"
          :items-per-page-text="$t('data_tables.rows_per_page')"
          :no-data-text="$t('data_tables.no_data')"
        >
          <template v-slot:item="props">
            <tr
            class="clickableTableRow"
            @click="gotoDetail(props.item.id)"
            >
              <td>{{props.item.name}}</td>
              <td>{{props.item.vehicles}}</td>
              <td>{{props.item.locations}}</td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </wrld-box>
  </wrld-container>
</template>

<script>
import router from '@/router'

export default {
  name: 'InternalFleet',
  data () {
    return {
      breadcrumbs: [
        { text: 'Wereldo', disabled: false, href: '#/' },
        { text: this.$i18n.tc('routes.routes', 2), disabled: true }
      ],
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: this.$i18n.t('routes.vehicles'), value: 'vehicles', sortable: false },
        { text: this.$i18n.t('routes.locations'), value: 'locations', sortable: false }
      ]
    }
  },
  computed: {
    allRoutes () {
      return {
        routes: [],
        isFetching: false
      }
    }
  },
  methods: {
    gotoDetail (routeID) {
      router.push({ name: 'RouteDetail', params: { routeID: routeID } })
    },
    gotoCreateRoute () {
      router.push({ name: 'RoutesCreate' })
    },
    fetchRoutes () {

    }
  }
}
</script>
